/**
 * Token Usage API client
 */

import { apiClient } from './client'

export interface TokenUsageStats {
  total_tokens: number
  total_input_tokens: number
  total_output_tokens: number
  total_cost_usd?: number
  operation_counts: Record<string, number>
  daily_tokens_total?: number
  daily_tokens_remaining?: number
}

export interface DocumentTokenUsage {
  document_id: string
  total_tokens: number
  total_input_tokens: number
  total_output_tokens: number
  total_cost_usd?: number
}

export interface TokenUsageRecord {
  id: string
  document_id?: string
  operation_type: string
  model: string
  provider: string
  input_tokens: number
  output_tokens: number
  total_tokens: number
  cost_usd?: number
  created_at: string
}

class TokenUsageAPI {
  /**
   * Get total token usage statistics for the current user
   */
  async getUserStats(
    startDate?: string,
    endDate?: string
  ): Promise<TokenUsageStats> {
    const params: Record<string, string> = {}
    if (startDate) params.start_date = startDate
    if (endDate) params.end_date = endDate
    
    return await apiClient.get('/api/token-usage/stats', { params })
  }

  /**
   * Get token usage for a specific document
   */
  async getDocumentUsage(documentId: string): Promise<DocumentTokenUsage> {
    return await apiClient.get(`/api/token-usage/document/${documentId}`)
  }

  /**
   * Get recent token usage records
   */
  async getRecentUsage(days: number = 30): Promise<{ records: TokenUsageRecord[] }> {
    return await apiClient.get('/api/token-usage/recent', {
      params: { days }
    })
  }
}

export const tokenUsageAPI = new TokenUsageAPI()
export default tokenUsageAPI

